var _circle, _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F618(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F46767",
    d: "M50.853 57.997l.007.002-.006-.004-.005.004z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#664E27",
    cx: 22,
    cy: 27,
    rx: 5,
    ry: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F46767",
    d: "M61.366 42.567c-.908-1.805-2.732-2.988-4.986-2.834-2.332.16-4.117 1.412-5.586 3.471-1.484-2.043-3.281-3.285-5.613-3.424-2.254-.139-4.068 1.063-4.963 2.877-.902 1.836-.943 4.238.91 6.967 1.822 2.686 9.482 8.193 9.727 8.371.244-.182 7.859-5.756 9.66-8.449 1.832-2.742 1.771-5.149.851-6.979z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M51.852 30.541c-1.863-4.088-4.67-6.133-7.477-6.133s-5.613 2.045-7.477 6.133c-.185.412.776 1.154 1.256.75 1.808-1.52 3.966-2.127 6.221-2.127s4.413.607 6.221 2.127c.479.404 1.44-.338 1.256-.75zM39.542 50.37c1.582-1.638-1.828-2.965-1.828-5.87s3.41-4.232 1.828-5.87c-1.893-1.962-6.021-.479-8.58-3.13 0 2.151 1.805 4.5 5.18 4.5 0 0-2.295.925-2.295 4.5s2.295 4.5 2.295 4.5c-3.375 0-5.18 2.349-5.18 4.5 2.559-2.651 6.687-1.168 8.58-3.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F618);
export default __webpack_public_path__ + "static/media/1f618.81fb6e8a84c069c9c1dc9b146d799ef9.svg";
export { ForwardRef as ReactComponent };